import { render, staticRenderFns } from "./secret-sync-rule.vue?vue&type=template&id=0f06a3f3&scoped=true&"
import script from "./secret-sync-rule.vue?vue&type=script&lang=js&"
export * from "./secret-sync-rule.vue?vue&type=script&lang=js&"
import style0 from "./secret-sync-rule.vue?vue&type=style&index=0&id=0f06a3f3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f06a3f3",
  null
  
)

export default component.exports